<template>
  <el-dialog title="Histórico de creditos " :visible.sync="dialog" width="70%" :close-on-click-modal="false">
    <el-form>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('periodo')">
            <el-select v-model="month" placeholder="Selecione  uma opção" @change="fetch()">
              <el-option v-for="row of options" :key="row.key" :label="row.label" :value="row.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col class='right' :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <el-pagination
            class="right"
            :page-size="limit"
            background
            :pager-count="5"
            @current-change="fetch"
            @size-change="changeSize"
            :current-page.sync="page"
            layout="sizes, prev, pager, next"
            :page-sizes="[50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000]"
            :total="total"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="tableData" stripe ref="tableData" style="width: 100%" size="mini" v-loading="loading">
      <el-table-column prop="createdAt" :label="$t('data')" width="160px" />
      <el-table-column prop="description" :label="$t('descricao')" />
      <el-table-column prop="value" :label="$t('valor')" width="120px" align="right">
        <template slot-scope="scope">
          <el-tag :closable="false" :type="scope.row.data < 0 ? 'danger' : 'success'">{{ scope.row.value }}</el-tag>
        </template>
      </el-table-column>
      <!--el-table-column prop="balance" :label="$t('saldo')" width="120px" align="right" /-->
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="done()">OK</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { CustomerService } from "@/services/customers/customers.services";
import moment from "moment";
import "moment/locale/pt-br";
export default {
  name: "PrePostLimitCreditHistory",
  props: ["customer"],
  methods: {
    done() {
      this.dialog = false;
    },
    fetch() {
      const vm = this;
      vm.loading = true;
      console.log('send', vm.customer, vm.month, vm.page, vm.limit)
      CustomerService.history(vm.customer, vm.month, vm.page, vm.limit)
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    changeSize(size) {
      const vm = this;
      vm.records = size;
      vm.fetch();
    },
    open() {
      const vm = this;
      vm.dialog = true;
      vm.fetch();
    },
  },
  mounted() {
    const vm = this;
    moment.locale("pt-br");
    const today = moment();
    vm.month = today.format("YYYY-MM");
    for (let i = 0; i < 6; i++) {
      vm.options.push({
        key: today.format("YYYY-MM"),
        label: `${today.format("MMM").toUpperCase()}/${today.format("YYYY")}`,
      });
      today.subtract(1, "month");
    }
  },
  data() {
    return {
      dialog: false,
      options: [],
      month: "",
      loading: false,
      limit: 100,
      tableData: [],
      total: 0,
      page: 1,
    };
  },
};
</script>
